import { FrontendLoggerService } from '../frontend-logger.service';
import { AuthLoginHistoryRecorder } from './auth-login-history.recorder';
import { AuthPostAuthenticationNavigator } from './auth-post-authentication.navigator';
import { AuthSessionClient } from './auth-session.client';

export class AuthCallbackCoordinator {
  private callbackHandled = false;

  constructor(
    private readonly session: AuthSessionClient,
    private readonly navigator: AuthPostAuthenticationNavigator,
    private readonly loginHistory: AuthLoginHistoryRecorder,
    private readonly logger: FrontendLoggerService
  ) {}

  initialize(): void {
    if (this.callbackHandled) {
      this.logger.debug('initAuth callback ya manejado', 'skip');
      return;
    }
    const query = globalThis.location?.search ?? '';
    if (!this.navigator.isAuth0CallbackQuery(query)) {
      this.logger.debug('initAuth sin parámetros de callback', query);
      return;
    }

    this.callbackHandled = true;
    this.logger.info('Procesando callback Auth0 (initAuth)');
    this.session.rawRedirectCallback().subscribe({
      next: (result) => {
        this.logger.info('Callback procesado (initAuth)', JSON.stringify(result));
        this.loginHistory.register(true, 'interactive', () => this.session.getUserProfile());
        this.navigator.route(result?.appState?.target || '/chat', 'initAuth');
      },
      error: (error) => {
        this.logger.error(
          'Error en handleRedirectCallback (initAuth)',
          error?.message || JSON.stringify(error)
        );
        this.loginHistory.register(false, 'failed', () => this.session.getUserProfile());
      },
    });
  }

  processIfNeeded(): void {
    const query = globalThis.location?.search ?? '';
    this.logger.debug('Revisando callback Auth0', query);
    if (this.callbackHandled) {
      this.logger.debug('Callback ya procesado', 'omit');
      return;
    }
    if (!this.navigator.isAuth0CallbackQuery(query)) {
      this.logger.debug('Sin parámetros de callback', 'none');
      return;
    }

    this.callbackHandled = true;
    this.logger.info('Procesando callback de Auth0');
    this.session.handleRedirectCallback().subscribe({
      next: (result) => {
        this.logger.info('Callback procesado', JSON.stringify(result));
        this.navigator.route(
          result?.appState?.target || '/chat',
          'processAuthCallbackIfNeeded'
        );
      },
      error: (error) => {
        this.logger.error(
          'Error en handleRedirectCallback suscripción',
          error?.message || JSON.stringify(error)
        );
      },
    });
  }
}
